import { IcaButton } from './IcaElements/IcaButton'

const Feedback = () => {
  return (
    <a href='https://forms.office.com/pages/responsepage.aspx?id=8NxrF-MsEEaWKtWcH1zp9nCWn6P_g31Hra5HbmrGx9lUNEFFTDI1V0pVUDFEU1RJMEhONU04TFJRSy4u&route=shorturl' target="_blank" rel="noreferrer">
      <IcaButton text='Lämna feedback' variation='subtle' small />
    </a>
  )
}

export default Feedback